import type { AnalysisResult } from '../domain/models';
import { renderDailyLog, renderTripLog } from '../domain/narrative/TemplateNarrativeProvider';

export function analysisToMarkdown(result: AnalysisResult): string {
  const header = [
    '# Timeline Local Studio Export',
    '',
    `- ファイル: ${result.fileName}`,
    `- スキーマ: ${result.schema}`,
    `- 点数: ${result.points.length}`,
    `- 滞在候補: ${result.visits.length}`,
    `- 移動区間: ${result.segments.length}`,
    `- 旅行候補: ${result.trips.length}`,
    '',
  ].join('\n');

  const daily = result.dailySummaries.map(renderDailyLog).join('\n\n');
  const trips = result.trips.map(renderTripLog).join('\n\n');

  return [header, '## 日次ログ', daily || '日次ログはありません', '', '## 旅行候補', trips || '旅行候補はありません'].join('\n');
}
